module.exports = __webpack_public_path__ + "static/img/Asia-blue4.f43ab5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Asia-blue4.png
// module id = Bs3m
// module chunks = 1